import {toSnakeCase} from '../../../functions/camelSnakeCaseConversion';
import {TemplateStructure} from '../types/templateStructure';

export function convertVariableSpansToText(htmlContent: string): string {
    if(!htmlContent) return '';
    
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlContent;
    
    // Replace variable spans with [snake_case] format
    const spans = tempDiv.querySelectorAll('span[data-label]');
    spans.forEach(span => {
        const variableName = span.getAttribute('data-label');
        if(variableName) {
            const snakeCaseVar = toSnakeCase(variableName);
            const textNode = document.createTextNode(`[${snakeCaseVar}]`);
            span.replaceWith(textNode);
        }
    });
    
    return tempDiv.textContent || '';
}

export function createVariableSpanElement(variableKey: string, variableValue: string): HTMLSpanElement {
    const span = document.createElement('span');
    span.className = 'variable';
    span.setAttribute('data-label', variableKey);
    span.setAttribute('contenteditable', 'false');
    span.textContent = variableValue;
    return span;
}

export function hasDisabledVariables(structure: TemplateStructure, disabledVariables: Record<string, any>): boolean {
    if(!structure || !disabledVariables || Object.keys(disabledVariables).length === 0) {
        return false;
    }

    const disabledKeys = Object.keys(disabledVariables);

    return structure.some((item) => {
        // Check text items
        if(item.type === 'text' && item.value) {
            return disabledKeys.some((key) => 
                item.value.includes(key) || item.value.includes(`[${toSnakeCase(key)}]`)
            );
        }

        // Check inline params
        if(item.type === 'inline' && item.params) {
            return item.params.some((param) => 
                param.value && disabledKeys.some((key) => 
                    param.value.includes(key) || param.value.includes(`[${toSnakeCase(key)}]`)
                )
            );
        }

        return false;
    });
}
